import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Counter from './Counter'

class AnimatedCounter extends Component {
    constructor(props) {
        super(props)

        this.state = { counter: props.count }

        // This does not affect what is shown, and is therefore not kept in state
        this.timer = undefined

        // Variable to check if the component is unmounting
        this.isUnMounting = false
    }

    componentDidUpdate(prevProps) {
        // Has the counter value changed?
        if (this.props.count === prevProps.count) {
            return
        }

        // Is the new counter value the same as what we are showing
        if (this.props.count === this.state.counter) {
            return
        }

        // Start traveling towards the new props.count
        this.travel()
    }

    componentWillUnmount() {
        // Make sure we know that the component is unmounting
        this.isUnMounting = true

        // Clear the timeout
        clearTimeout(this.timer)
    }

    travel() {
        // If we are unmounting, do nothing
        if (this.isUnMounting) {
            return
        }

        // Imagine we are traveling along the X-axis in a one dimensional world

        // What we are currently at
        const currentLocation = this.state.counter

        // Where we want to end up
        const endLocation = this.props.count

        // We are already where we want to be
        if (currentLocation === endLocation) {
            return
        }

        // First get how far from our goal we are
        const distance = Math.abs(endLocation - currentLocation)

        // Now calculate how far we want to travel towards our goal right now (about 1%)
        let travelDistance = Math.floor(distance / 100) + 1
        if (currentLocation > endLocation) {
            // If we are going down, we need to travel down
            travelDistance *= -1
        }

        // Update our new destination
        const destination = currentLocation + travelDistance
        this.setState({ counter: destination })

        // Calculate how long we want to wait until we continue traveling
        // We want to go fast in the beginning and then slow down
        const timeToWait = 300 / (distance + 1)
        this.timer = setTimeout(() => {
            this.travel()
        }, timeToWait)
    }

    render() {
        if (this.props.hide) return null

        return <Counter count={this.state.counter} />
    }
}

AnimatedCounter.propTypes = {
    count: PropTypes.number,
    hide: PropTypes.bool,
}

export default AnimatedCounter



// WEBPACK FOOTER //
// ./src/features/ServerMenu/components/Menu/components/AnimatedCounter/component.js